export const TextAdvice = ({ children, width = '100%', warning }) => {
    return (
        <p
            className={warning ? 'text__warning' : 'text__center'}
            style={{
                paddingTop: '.5rem',
                fontSize: '12px',
                width,
                textAlign: warning ? 'justify' : 'center',
            }}
        >
            <b>{children}</b>
        </p>
    );
};
